/* Presentation only. Shopify validates ACCESOCYBER; no cart totals are changed. */
(() => {
  if (!window.TDCyber || customElements.get('td-cyber-price')) return;
  const campaign = window.TDCyber;
  let expiryTimer;

  const customPriceSelectors = [
    '.tdmv-price',
    '.td-food-tag',
    '.td-prices',
    '.td-feed-prices',
    '.td-rest-prices',
    '.tdsofa-price',
    '.td-auto-product__price',
    '.td-auto-prices',
    '.td-rampa-tag',
    '.td-nails-post-tag',
    '.tdc-price',
    '.td-price-row',
    '.tdn-price-row',
    '.tdcy__prices',
    '.tdn-price',
    '.td-card__price',
    '.td-compare-card__price',
    '.td-support-card__action > strong',
    '.td-mini-card__body p',
    '.td-food__price-row',
    '.td-food__card-price-row',
    '.tdc-pdp-preview__price',
    '.td-bed__price-row'
  ].join(',');

  function isHiddenPriceNode(node) {
    if (!node || node.hidden || node.matches('.hidden, .is-hidden') || node.getAttribute('aria-hidden') === 'true') return true;
    if (node.style?.display === 'none' || node.style?.visibility === 'hidden') return true;
    if (node.closest('[hidden], [aria-hidden="true"], .hidden, .is-hidden, [style*="display: none"], [style*="display:none"], [style*="visibility: hidden"], [style*="visibility:hidden"]')) return true;
    if (typeof getComputedStyle === 'function') {
      const style = getComputedStyle(node);
      if (style.display === 'none' || style.visibility === 'hidden') return true;
    }
    return false;
  }

  function findCurrentPriceNode(priceBlock) {
    if (!priceBlock) return null;
    const selector = [
      '[data-base-price]:not([hidden]) .tdcy__price-value',
      '[data-tdc-selected-price]',
      '[data-bed-price]',
      '[data-td-bed-size-price-value]',
      '[data-card-price]',
      '.tdc-price-current',
      '.td-food__price',
      '.td-food__card-price',
      '.td-price--current',
      '.td-feed-price--current',
      '.td-rest-price--current',
      '.td-auto-price--current',
      '.td-auto-product__current',
      '.td-price-row > .td-price',
      '.price-item--sale',
      'strong:not([hidden])'
    ].join(',');
    if (priceBlock.matches(selector) && !isHiddenPriceNode(priceBlock)) return priceBlock;
    return Array.from(priceBlock.querySelectorAll(selector)).find(node => {
      return !isHiddenPriceNode(node) && numericPrice(node) > 0;
    }) || null;
  }

  function hasVerifiedComparePrice(priceBlock) {
    const currentValue = currentPriceValue(priceBlock);
    if (!currentValue) return false;
    return Array.from(priceBlock.querySelectorAll('s, del, .tdc-price-compare')).some(node => {
      return !isHiddenPriceNode(node) && numericPrice(node) > currentValue;
    });
  }

  function innermostPriceMatches(matches) {
    return matches.filter(node => !matches.some(other => other !== node && node.contains(other)));
  }

  function canLabelCustomPrice(priceBlock, signal) {
    if (!priceBlock || priceBlock.querySelector('.td-cyber-public-price-label')) return false;
    if (!/\d/.test(priceBlock.textContent || '')) return false;
    const explicitVariantCard = priceBlock.closest('a[href*="variant="]');
    // Aggregate product cards often mix price_min with compare_at_price_max.
    // A generic crossed-out value is therefore not enough evidence that the
    // displayed minimum is discounted. Non-exact cards are handled below only
    // when the Liquid badge exposes the verified discounted minimum.
    if (signal !== 'exact' && !explicitVariantCard) return false;
    return signal === 'exact' || hasVerifiedComparePrice(priceBlock);
  }

  function findCustomPriceBlock(badge) {
    const signal = badge.dataset.tdCyberPriceSignal || '';
    let cursor = badge.parentElement;
    let depth = 0;

    while (cursor && depth < 12) {
      if (cursor.matches('section, header, footer, main, body')) return null;
      if (cursor.querySelectorAll('[data-td-cyber-badge][data-td-cyber-price-signal]').length > 1) return null;
      const candidates = cursor.matches(customPriceSelectors)
        ? [cursor]
        : Array.from(cursor.querySelectorAll(customPriceSelectors));
      const siblingPrices = candidates.filter(node => !node.contains(badge));
      if (siblingPrices.some(node => node.querySelector('.td-cyber-public-price-label'))) return null;
      const matches = innermostPriceMatches(
        siblingPrices.filter(node => canLabelCustomPrice(node, signal))
      );
      if (matches.length === 1) return matches[0];
      if (matches.length > 1) return null;
      cursor = cursor.parentElement;
      depth += 1;
    }
    return null;
  }

  function syncCustomPriceLabel(priceBlock, label, signal, requiresCompareEvidence) {
    const shouldShow = requiresCompareEvidence
      ? hasVerifiedComparePrice(priceBlock)
      : signal === 'exact';
    const shouldHide = !shouldShow;
    if (label.hidden !== shouldHide) label.hidden = shouldHide;
  }

  function placeCustomPriceLabel(priceBlock, label) {
    const currentPrice = findCurrentPriceNode(priceBlock);
    if (currentPrice === priceBlock) {
      if (label.parentNode !== priceBlock || priceBlock.lastElementChild !== label) priceBlock.append(label);
    } else if (currentPrice && currentPrice.parentNode) {
      if (currentPrice.nextElementSibling !== label) currentPrice.after(label);
    } else if (label.parentNode !== priceBlock || priceBlock.lastElementChild !== label) {
      priceBlock.append(label);
    }
  }

  function insertCustomPriceLabel(priceBlock, signal) {
    if (!priceBlock || priceBlock.querySelector('.td-cyber-public-price-label')) return;
    const requiresCompareEvidence = Boolean(priceBlock.querySelector('s, del, .tdc-price-compare'));
    const label = document.createElement('span');
    label.className = 'td-cyber-public-price-label td-cyber-public-price-label--custom';
    label.setAttribute('data-td-cyber-public-price-label', '');
    label.dataset.tdCyberPriceSignal = signal;
    label.textContent = 'Precio Cyber';

    placeCustomPriceLabel(priceBlock, label);
    syncCustomPriceLabel(priceBlock, label, signal, requiresCompareEvidence);
    if (typeof MutationObserver !== 'undefined') {
      const observer = new MutationObserver(records => {
        if (records.every(record => record.target === label)) return;
        placeCustomPriceLabel(priceBlock, label);
        syncCustomPriceLabel(priceBlock, label, signal, requiresCompareEvidence);
      });
      observer.observe(priceBlock, {
        subtree: true,
        childList: true,
        characterData: true,
        attributes: true,
        attributeFilter: ['hidden', 'class', 'style']
      });
    }
  }

  function numericPrice(node) {
    const digits = (node?.textContent || '').replace(/[^0-9]/g, '');
    return digits ? Number(digits) : 0;
  }

  function currentPriceValue(priceBlock) {
    const current = findCurrentPriceNode(priceBlock);
    if (current) return numericPrice(current);
    if (!priceBlock) return 0;
    const copy = priceBlock.cloneNode(true);
    copy.querySelectorAll('s, del, .tdc-price-compare, .td-cyber-public-price-label, [hidden], [aria-hidden="true"]').forEach(node => node.remove());
    return numericPrice(copy);
  }

  function firstDisplayedPriceValue(priceBlock) {
    if (!priceBlock) return 0;
    const copy = priceBlock.cloneNode(true);
    copy.querySelectorAll('s, del, .tdc-price-compare, .td-cyber-public-price-label, [hidden], [aria-hidden="true"]').forEach(node => node.remove());
    const match = (copy.textContent || '').match(/(?:CLP\s*)?\$?\s*(\d{1,3}(?:[.\s]\d{3})+|\d+)/i);
    return match ? Number(match[1].replace(/[^0-9]/g, '')) : 0;
  }

  function syncGemPriceLabel(priceBlock, label) {
    const current = priceBlock.querySelector('.gf_product-price');
    const currentValue = numericPrice(current);
    const availability = gemPriceAvailability(priceBlock);
    const hasVerifiedSavings = Boolean(current && !isHiddenPriceNode(current) && currentValue) &&
      availability !== false &&
      Array.from(priceBlock.querySelectorAll('.gf_product-compare-price')).some(compare => {
        return !isHiddenPriceNode(compare) && numericPrice(compare) > currentValue;
      });

    if (current && (!priceBlock.contains(label) || current.nextElementSibling !== label)) {
      current.after(label);
    }
    label.hidden = !hasVerifiedSavings;
  }

  function gemPriceAvailability(priceBlock) {
    const form = priceBlock.closest('form');
    const selectedId = form?.querySelector('[name="id"]')?.value || '';
    const productId = priceBlock.closest('[data-pid]')?.dataset.pid || '';
    const jsonNodes = form ? Array.from(form.querySelectorAll('script.product-json')) : [];
    const externalJson = productId ? document.getElementById(`product-json${productId}`) : null;
    if (externalJson && !jsonNodes.includes(externalJson)) jsonNodes.push(externalJson);

    for (const node of jsonNodes) {
      try {
        const productData = JSON.parse(node.textContent || '{}');
        const variants = Array.isArray(productData.variants) ? productData.variants : [];
        const selectedVariant = variants.find(variant => String(variant.id) === String(selectedId));
        if (selectedVariant) return selectedVariant.available !== false;
        if (!selectedId && typeof productData.available === 'boolean') return productData.available;
      } catch (_) {}
    }

    if (!form) return null;

    const addButton = form.querySelector('.gf_add-to-cart, [name="add"]');
    if (addButton?.disabled || addButton?.getAttribute('aria-disabled') === 'true') return false;

    const options = Array.from(form.querySelectorAll('.gf_variants option'));
    if (options.length) {
      const selectedOption = options.find(option => String(option.value || '') === String(selectedId || ''));
      if (selectedOption) return !selectedOption.disabled;
      if (!options.some(option => !option.disabled && option.value)) return false;
    }

    const soldOutText = priceBlock.closest('[data-pid]')?.dataset.soldouttext || '';
    const buttonText = form.querySelector('.AddToCartText')?.textContent?.trim() || '';
    if (soldOutText && buttonText && soldOutText.trim() === buttonText) return false;
    return null;
  }

  function enhanceGemPriceBlock(priceBlock) {
    if (priceBlock.hasAttribute('data-td-cyber-price-enhanced')) return;
    priceBlock.setAttribute('data-td-cyber-price-enhanced', '');

    const label = document.createElement('span');
    label.className = 'td-cyber-public-price-label td-cyber-public-price-label--custom';
    label.setAttribute('data-td-gem-cyber-price-label', '');
    label.textContent = 'Precio Cyber';
    syncGemPriceLabel(priceBlock, label);

    if (typeof MutationObserver !== 'undefined') {
      const observer = new MutationObserver(records => {
        if (records.every(record => record.target === label)) return;
        syncGemPriceLabel(priceBlock, label);
      });
      observer.observe(priceBlock, {
        subtree: true,
        childList: true,
        characterData: true,
        attributes: true,
        attributeFilter: ['hidden', 'class', 'style']
      });
    }
  }

  function refreshGemPriceLabels() {
    document.querySelectorAll('.gf_product-prices').forEach(enhanceGemPriceBlock);
  }

  function refreshGemPricesIn(container) {
    if (!container) return;
    container.querySelectorAll('.gf_product-prices').forEach(priceBlock => {
      const label = priceBlock.querySelector('[data-td-gem-cyber-price-label]');
      if (label) syncGemPriceLabel(priceBlock, label);
    });
  }

  const verifiedLandingPrices = [
    {
      root: '#td-signature-after-grid',
      prices: ['.td-signature-proof li:first-child', '.td-signature-final p', '.td-signature-sticky > div > span']
    },
    {
      root: '#td-piel-after-grid',
      prices: ['.td-piel-proof li:first-child', '.td-piel-final p', '.td-piel-sticky > div > span']
    },
    {
      root: '#td-majestuoso-after-grid',
      prices: ['.td-majestuoso-proof li:first-child', '.td-majestuoso-final p', '.td-majestuoso-sticky > div > span']
    },
    {
      root: '#td-nails-meta-landing',
      prices: ['.td-nails-proof li:first-child', '.td-nails-final .td-nails-kicker', '.td-nails-sticky-cta > span:first-child']
    },
    {
      root: '[id^="td-elevada-pdp-"]',
      prices: ['.td-price-row', '.td-sticky-title > span']
    }
  ];

  function refreshVerifiedLandingPriceLabels() {
    verifiedLandingPrices.forEach(config => {
      const root = document.querySelector(config.root);
      if (!root || !root.querySelector(
        '[data-td-cyber-badge][data-td-cyber-min-price-sale], ' +
        '[data-td-cyber-badge][data-td-cyber-price-signal="exact"]'
      )) return;
      config.prices.forEach(selector => {
        const priceBlock = root.querySelector(selector);
        insertCustomPriceLabel(priceBlock, 'exact');
        const label = priceBlock?.querySelector('.td-cyber-public-price-label');
        if (label) label.classList.add('td-cyber-public-price-label--landing');
      });
    });
  }

  function syncLegacyNailsSticky(root) {
    const price = root?.querySelector('[data-tdn-sticky-price]');
    const mainPrice = root?.querySelector('[data-tdn-price]');
    const variantsNode = root?.querySelector('[data-tdn-variants]');
    if (!price || !mainPrice || !variantsNode) return;

    let variants;
    try { variants = JSON.parse(variantsNode.textContent || '[]'); } catch (_) { return; }
    if (!Array.isArray(variants)) return;

    const selectedId = root.querySelector('[data-tdn-variant-input]')?.value || '';
    const variant = variants.find(item => String(item.id) === String(selectedId));
    let mainLabel = root.querySelector('[data-tdn-legacy-cyber-label]');
    let stickyLabel = root.querySelector('[data-tdn-sticky-cyber-label]');

    if (!mainLabel) {
      mainLabel = document.createElement('span');
      mainLabel.className = 'td-cyber-public-price-label';
      mainLabel.setAttribute('data-tdn-legacy-cyber-label', '');
      mainLabel.textContent = 'Precio Cyber';
      mainPrice.after(mainLabel);
    }

    if (!stickyLabel) {
      stickyLabel = document.createElement('span');
      stickyLabel.className = 'td-cyber-public-price-label td-cyber-public-price-label--landing';
      stickyLabel.setAttribute('data-tdn-sticky-cyber-label', '');
      stickyLabel.textContent = 'Precio Cyber';
      price.after(stickyLabel);
    }

    const isDiscounted = Boolean(
      variant?.available &&
      Number(variant.compare_at_price || 0) > Number(variant.price || 0)
    );
    mainLabel.hidden = !isDiscounted;
    stickyLabel.hidden = !isDiscounted;
  }

  function refreshLegacyNailsStickyLabels(container = document) {
    if (container?.matches?.('[data-tdn-root]')) syncLegacyNailsSticky(container);
    container?.querySelectorAll?.('[data-tdn-root]').forEach(syncLegacyNailsSticky);
  }

  function refreshVerifiedMinPriceCards() {
    document.querySelectorAll('[data-td-cyber-badge][data-td-cyber-min-price-sale]').forEach(badge => {
      let priceBlock = null;
      const minPriceCents = Number(badge.dataset.tdCyberMinPriceSale || 0);
      let cursor = badge.parentElement;
      let depth = 0;
      while (!priceBlock && cursor && depth < 12) {
        if (cursor.matches('section, header, footer, main, body')) break;
        if (cursor.querySelectorAll('[data-td-cyber-badge][data-td-cyber-min-price-sale]').length > 1) break;
        const candidates = cursor.matches(customPriceSelectors)
          ? [cursor]
          : Array.from(cursor.querySelectorAll(customPriceSelectors));
        const matches = innermostPriceMatches(candidates.filter(node => {
          if (node.contains(badge) || node.querySelector('.td-cyber-public-price-label')) return false;
          const displayedPrice = currentPriceValue(node);
          const firstDisplayedPrice = firstDisplayedPriceValue(node);
          const allVariantsDiscounted = badge.dataset.tdCyberPriceSignal === 'all';
          return minPriceCents > 0 && (
            displayedPrice * 100 === minPriceCents ||
            (allVariantsDiscounted && firstDisplayedPrice * 100 === minPriceCents)
          );
        }));
        if (matches.length === 1) priceBlock = matches[0];
        if (matches.length > 1) break;
        cursor = cursor.parentElement;
        depth += 1;
      }
      insertCustomPriceLabel(priceBlock, 'exact');
    });
  }

  /*
   * Product configurators render several exact variant prices after this file
   * has loaded. They cannot be paired safely with the image badge by proximity,
   * so verify each price row directly instead: a visible compare-at price must
   * be greater than the displayed price. This covers Funda Magica's piece
   * builder and the Original, Luxury and Elevated bed size cards.
   */
  const verifiedOptionPriceSelector = [
    '.td-funda-builder__price',
    '[data-td-bed-size-prices]'
  ].join(',');

  const verifiedOptionRootSelector = [
    '[data-td-funda-builder]',
    '[data-td-bed-size-fieldset]'
  ].join(',');

  function elementsWithin(container, selector) {
    if (!container) return [];
    const matches = container.matches?.(selector) ? [container] : [];
    return matches.concat(Array.from(container.querySelectorAll?.(selector) || []));
  }

  function refreshVerifiedOptionPriceLabels(container = document) {
    elementsWithin(container, verifiedOptionPriceSelector).forEach(priceBlock => {
      let label = priceBlock.querySelector('.td-cyber-public-price-label');

      if (!label && hasVerifiedComparePrice(priceBlock)) {
        insertCustomPriceLabel(priceBlock, 'exact');
        label = priceBlock.querySelector('.td-cyber-public-price-label');
      }

      if (!label) return;
      if (label.textContent !== 'Precio Cyber') label.textContent = 'Precio Cyber';
      placeCustomPriceLabel(priceBlock, label);
      syncCustomPriceLabel(priceBlock, label, 'exact', true);
    });

    elementsWithin(container, verifiedOptionRootSelector).forEach(root => {
      if (root.hasAttribute('data-td-cyber-option-prices-observed')) return;
      root.setAttribute('data-td-cyber-option-prices-observed', '');
      if (typeof MutationObserver === 'undefined') return;

      let refreshQueued = false;
      const observer = new MutationObserver(() => {
        if (refreshQueued) return;
        refreshQueued = true;
        queueMicrotask(() => {
          refreshQueued = false;
          refreshVerifiedOptionPriceLabels(root);
        });
      });

      observer.observe(root, {
        subtree: true,
        childList: true,
        characterData: true,
        attributes: true,
        attributeFilter: ['hidden', 'class', 'style']
      });
    });
  }

  function refreshPublicPriceLabels() {
    document.querySelectorAll('[data-td-cyber-badge][data-td-cyber-price-signal]').forEach(badge => {
      if (badge.hasAttribute('data-td-cyber-price-enhanced')) return;
      if (badge.closest('[data-tdn-root]')) return;
      const priceBlock = findCustomPriceBlock(badge);
      if (priceBlock) {
        insertCustomPriceLabel(priceBlock, badge.dataset.tdCyberPriceSignal || '');
        badge.setAttribute('data-td-cyber-price-enhanced', '');
      }
    });
    refreshVerifiedLandingPriceLabels();
    refreshVerifiedMinPriceCards();
    refreshVerifiedOptionPriceLabels();
  }

  function refreshContext() {
    if (campaign.redirectIfEnded()) return;
    const active = campaign.active();
    document.documentElement.classList.toggle('td-cyber-access', active);
    document.documentElement.classList.toggle('td-cyber-badge-live', campaign.badgeActive());
    refreshPublicPriceLabels();
    refreshGemPriceLabels();
    refreshLegacyNailsStickyLabels();
    try {
      if (active) sessionStorage.setItem('td-cyber-access-2026', campaign.config.endsAt);
      else sessionStorage.removeItem('td-cyber-access-2026');
    } catch (_) {}
    document.dispatchEvent(new CustomEvent('td:cyber:change'));
    clearTimeout(expiryTimer);
    const now = Date.now();
    const nextBoundary = [
      campaign.config.startsAt,
      campaign.config.endsAt,
      campaign.config.badgeStartsAt,
      campaign.config.badgeEndsAt
    ]
      .map(value => Date.parse(value))
      .filter(value => Number.isFinite(value) && value > now)
      .sort((a, b) => a - b)[0];
    if (nextBoundary) expiryTimer = setTimeout(refreshContext, Math.min(nextBoundary - now + 20, 2147483647));
  }

  class TDCyberPrice extends HTMLElement {
    connectedCallback() {
      const json = this.querySelector('[data-td-cyber-variants]');
      if (!json) return;
      try { this.variants = JSON.parse(json.textContent); } catch (_) {
        this.removeAttribute('data-available');
        return;
      }
      this.onChange = () => this.sync();
      document.addEventListener('change', this.onChange);
      document.addEventListener('td:cyber:change', this.onChange);
      this.sync();
    }

    disconnectedCallback() {
      document.removeEventListener('change', this.onChange);
      document.removeEventListener('td:cyber:change', this.onChange);
    }

    currentVariant() {
      const picker = document.querySelector(`#MainProduct-${CSS.escape(this.dataset.sectionId)} variant-radios, #MainProduct-${CSS.escape(this.dataset.sectionId)} variant-selects`);
      if (picker && Object.prototype.hasOwnProperty.call(picker, 'currentVariant') && !picker.currentVariant) return null;
      const form = document.getElementById(`product-form-${this.dataset.sectionId}`);
      const id = form?.querySelector('[name="id"]')?.value || this.dataset.selectedId;
      return this.variants?.find(variant => String(variant.id) === String(id)) || null;
    }

    getVariantQuote(variantId, quantity = 1, options = {}) {
      if (!campaign.active()) return null;
      const variant = this.variants?.find(item => String(item.id) === String(variantId));
      const requireAvailable = options.requireAvailable !== false;
      if (!variant || (requireAvailable && !variant.available)) return null;
      const count = Number(quantity);
      if (!Number.isInteger(count) || count < 1) return null;
      return {
        price: variant.offer * count,
        compareAtPrice: variant.price * count,
        available: Boolean(variant.available)
      };
    }

    getQuote(variantId, quantity = 1) {
      const variant = this.currentVariant();
      if (!variant || String(variant.id) !== String(variantId)) return null;
      return this.getVariantQuote(variantId, quantity);
    }

    sync() {
      const variant = this.currentVariant();
      this.toggleAttribute('data-available', Boolean(variant?.available));
      if (variant) {
        const beforeWrap = this.querySelector('[data-td-cyber-before-wrap]');
        const before = this.querySelector('[data-td-cyber-before]');
        const current = this.querySelector('[data-td-cyber-current]');
        const final = this.querySelector('[data-td-cyber-final]');
        const hasBefore = Boolean(variant.beforeText);
        if (beforeWrap) beforeWrap.hidden = !hasBefore;
        if (before && before.textContent !== variant.beforeText) before.textContent = variant.beforeText;
        if (current && current.textContent !== variant.currentText) current.textContent = variant.currentText;
        if (final && final.textContent !== variant.offerText) final.textContent = variant.offerText;
      }
      // The theme's sticky bar listens to this, including midnight expiry.
      document.dispatchEvent(new CustomEvent('td:cyber:price', { detail: { sectionId: this.dataset.sectionId } }));
    }
  }

  class TDCyberCartNote extends HTMLElement {
    connectedCallback() {
      this.update = () => { this.hidden = !campaign.active(); };
      document.addEventListener('td:cyber:change', this.update);
      this.update();
    }
    disconnectedCallback() { document.removeEventListener('td:cyber:change', this.update); }
  }

  customElements.define('td-cyber-price', TDCyberPrice);
  customElements.define('td-cyber-cart-note', TDCyberCartNote);
  window.addEventListener('pageshow', refreshContext);
  document.addEventListener('shopify:section:load', () => {
    refreshPublicPriceLabels();
    refreshGemPriceLabels();
    refreshLegacyNailsStickyLabels();
  });
  document.addEventListener('change', event => {
    refreshGemPricesIn(event.target?.closest?.('form'));
    queueMicrotask(() => refreshLegacyNailsStickyLabels(event.target?.closest?.('[data-tdn-root]') || document));
  });
  document.addEventListener('visibilitychange', () => { if (!document.hidden) refreshContext(); });
  refreshContext();
})();